import { ordersBackService } from '@/services';

export const ordersBackListModule = {
  namespaced: true,
  state: () => ({
    list:{
      data: null,
      error: null,
    },
    listFilters: {},
    orderBack:{
      data: null,
      error: null,
    },
    ordersBackExcel:{
      data: null,
      error: null,
    },
    orderTracking:{
      data: null,
      error: null,
    },
    orderBackResource:{
      data: {
        images: null,
        documents: null,
      },
      error: null
    },
    payOrRevert:{
      data: null,
      status: null
    },
    onHoldStatus:{
      data: null,
      status: null
    },
    cancelEntity:{
      data: null,
      status: null,
    },
    recoverEntity:{
      data: null,
      status: null,
    },
  }),
  mutations: {
    loadResource(state, orderBackId) {
      ordersBackService.getResources(orderBackId)
        .then((res) => {
          state.orderBackResource.data = { ...res }
        })
        .catch((error) => {
          state.orderBackResource.data.images = null
          state.orderBackResource.data.documents = null
          state.orderBackResource.error = error
        });      
    },
    appendImage(state, entity) {
      state.orderBackResource.data.images.push(entity)
    },
    appendDocument(state, entity) {
      state.orderBackResource.data.documents.push(entity)
    },
    removeImage(state, entity) {
      const currentImages = [ ...state.orderBackResource.data.images ]
      state.orderBackResource.data.images = currentImages.filter(image => image['name'] != entity['name'])
    },
    removeDocument(state, entity) {
      const currentDocuments = [ ...state.orderBackResource.data.documents ]
      state.orderBackResource.data.documents = [ ...currentDocuments.filter(document => document['name'] != entity['name']) ]
    },
    downloadResource(state,request){
      ordersBackService.downloadResource(request.orderBackId, request.fileName)
      .then((excel) => {
        state.orderBackResource.data = excel
        state.orderBackResource.error = null
      })
      .catch((error) => {
        state.orderBackResource.data = null
        state.orderBackResource.error = error
      });
    },
    resetResources(state) {
      state.orderBackResource.data.images = null
      state.orderBackResource.data.documents = null
      state.orderBackResource.error = null     
    },
    load(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
      ordersBackService.getOrdersBack(request.pagination, request.filters)
        .then((res) => {
          state.list.data = res
        })
        .catch((error) => {
          state.list.data = null
          state.list.error = error
        });      
    },
    getById(state, id) {
      ordersBackService.getOrderBackById(id)
        .then((res) => {
          state.orderBack.data = res
        })
        .catch((error) => {
          state.orderBack.data = null
          state.orderBack.error = error
        });      
    },
    ordersBackExcel(state,request){
      ordersBackService.getOrdersBackAsExcel(request.filters, request.language)
      .then((excel) => {
        state.ordersBackExcel.data = excel
        state.ordersBackExcel.error = null
      })
      .catch((error) => {
        state.ordersBackExcel.data = null
        state.ordersBackExcel.error = error
      });
    },
    getTracking(state, orderId) {
      ordersBackService.getTracking(orderId)
        .then((res) => {
          state.orderTracking.data = res
        })
        .catch((error) => {
          state.orderTracking.data = null
          state.orderTracking.error = error
        });      
    },
    payOrRevert(state, payload){
      ordersBackService.payOrRevert({ with_paid: payload.with_paid, paid_date: payload.paid_date }, payload.entityId)
      .then((res) => {
        state.payOrRevert.data = { ...res }
        state.payOrRevert.status = {
          created: true,
        }
      })
      .catch((error) => {
        state.payOrRevert.data = null
        state.payOrRevert.status = {
          ...error
        }
      }); 
    },
    onHoldStatus(state, payload){
      ordersBackService.onHoldStatus({ on_hold: payload.on_hold }, payload.entityId)
      .then((res) => {
        state.onHoldStatus.data = { ...res }
        state.onHoldStatus.status = {
          onHoldStatus: true
        }
      })
      .catch((error) => {
        state.onHoldStatus.data = null
        state.onHoldStatus.status = {
          ...error
        }
      }); 
    },
    cancel(state, entityId){
      ordersBackService.cancel(entityId)
      .then((res) => {
        state.cancelEntity.data = { ...res }
        state.cancelEntity.status = {
          canceled: true,
        }
      })
      .catch((error) => {
        state.cancelEntity.data = null
        state.cancelEntity.status = {
          ...error
        }
      }); 
    },
    recover(state, entityId){
      ordersBackService.recover(entityId)
      .then((res) => {
        state.recoverEntity.data = { ...res }
        state.recoverEntity.status = {
          recovered: true,
        }
      })
      .catch((error) => {
        state.recoverEntity.data = null
        state.recoverEntity.status = {
          ...error
        }
      }); 
    },
  }
}